import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('report.projectedPremierVolume.content');
  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );
  const updatedOrderType = updatePremierPlus ? 'Premier+' : 'Premier';

  return (
    <View>
      <Gutter style={styles.base}>
        <Text variant="subheading" emphasis="low" style={styles.label}>
          {tt('attribute.header', `Scheduled ${updatedOrderType} Order`)}
        </Text>
        <View style={styles.value}>
          <LoadingBox style={styles.loadingBoxSubheader} />
        </View>
      </Gutter>
      <Gutter>
        <View style={[styles.attributeLine, styles.borderTop]}>
          <Text emphasis="medium">
            {tt('attribute.orderValue', 'Order Value')}
          </Text>
          <LoadingBox style={styles.loadingBoxOrderValue} />
        </View>
        <View style={styles.attributeLine}>
          <Text emphasis="medium">
            {tt('attribute.scheduleDate', 'Scheduled Date')}
          </Text>
          <LoadingBox style={styles.loadingBoxScheduledDate} />
        </View>
        <View style={styles.attributeLine}>
          <Text emphasis="medium">{tt('attribute.cv', 'CV')}</Text>
          <LoadingBox style={styles.loadingBoxCV} />
        </View>
        {updatePremierPlus ? (
          ''
        ) : (
          <View style={styles.attributeLine}>
            <Text emphasis="medium">
              {tt('attribute.rewardsBalance', 'Rewards Balance')}
            </Text>
            <LoadingBox style={styles.loadingBoxRewardsBalance} />
          </View>
        )}
      </Gutter>
    </View>
  );
};
